import { render } from "./BrandDetail.vue?vue&type=template&id=4b24f382&scoped=true"
import script from "./BrandDetail.vue?vue&type=script&lang=js"
export * from "./BrandDetail.vue?vue&type=script&lang=js"

import "./BrandDetail.vue?vue&type=style&index=0&id=4b24f382&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b24f382"]])

export default __exports__